/* eslint-disable prettier/prettier */
import React from 'react';
import clsx from 'clsx';

interface ComparisonTableProps {
  data: Record<
    string,
    {
      left: any;
      right: any;
      isDifferent: boolean;
    }
  >;
  fieldLabels?: Record<string, string>;
  firstLabel?: string;
  showDifferences?: boolean;
}

export const ComparisonTable = ({
  data,
  fieldLabels = {},
  firstLabel,
  showDifferences = false,
}: ComparisonTableProps) => {
  const filteredEntries = Object.entries(data).filter(
    ([_, value]) => !showDifferences || value.isDifferent,
  );

  if (filteredEntries.length === 0) return null; 

  return (
    <table className="w-full text-sm border border-collapse border-gray-300 rounded">
      <thead>
        <tr className="text-sm font-semibold text-left bg-gray-50 text-muted-foreground">
          <th className="w-1/3 p-2 border border-gray-300">{firstLabel ?? 'Field'}</th>
          <th className="w-1/3 p-2 border border-gray-300">Version 1</th>
          <th className="w-1/3 p-2 border border-gray-300">Version 2</th>
        </tr>
      </thead>
      <tbody>
        {filteredEntries.map(([key, value]) => (
          <tr
            key={key}
            className={clsx({
              'bg-highlight': value.isDifferent,
              'bg-white': !value.isDifferent,
            })}
          >
            <td className="p-2 font-medium border border-gray-300 text-primary">
              {fieldLabels[key] || key}
            </td>
            <td className="p-2 border border-gray-300 text-muted-foreground">
              {renderValue(value.left)}
            </td>
            <td className="p-2 border border-gray-300 text-muted-foreground">
              {renderValue(value.right)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const renderValue = (val: any) => {
  if (Array.isArray(val)) return val.join(', ');
  if (typeof val === 'boolean') return val ? 'Yes' : 'No';
  if (val === null || val === undefined) return '-';
  return val.toString();
};
